(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fabric-product"]) return;
  try {
    document.addEventListener("change",function(event){if(!event.target.matches("[data-product-variant]"))return;const root=event.target.closest("[data-product-detail]");const option=event.target.selectedOptions[0];root.querySelector("[data-product-price]").textContent=option.dataset.price;const picture=root.querySelector(".product-gallery img");if(picture&&option.dataset.image){picture.removeAttribute("srcset");picture.src=option.dataset.image;}const url=new URL(window.location.href);url.searchParams.set("variant",option.value);history.replaceState({}, "", url);});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fabric-shop"] && !Shopify.designMode) return;
  try {
    
function initIndependentLabel(root){
  if(root.dataset.labelBound)return;
  root.dataset.labelBound='true';
  root.addEventListener('click',function(event){
    const button=event.target.closest('[data-filter]');
    if(!button)return;
    root.querySelectorAll('[data-filter]').forEach(function(item){
      item.setAttribute('aria-pressed',item===button?'true':'false');
    });
    const filter=button.dataset.filter;
    let visible=0;
    root.querySelectorAll('[data-category]').forEach(function(card){
      const show=filter==='all'||card.dataset.category===filter;
      card.hidden=!show;
      if(show)visible+=1;
    });
    const empty=root.querySelector('[data-empty]');
    if(empty)empty.hidden=visible!==0;
  });
}
function initIndependentLabels(){document.querySelectorAll('[data-shop-section]').forEach(initIndependentLabel);}
initIndependentLabels();
document.addEventListener('shopify:section:load',initIndependentLabels);

  } catch(e) { console.error(e); }
})();
})();
